// What the Workspace datasets part's REST answers (the screen imports these
// from `@trameria/cloud-api/workspace-datasets-shared`).
import type { DatasetDTO } from "@trameria/core/datasets-shared";

export type { DatasetDTO };

export interface WsDatasetList {
  datasets: DatasetDTO[];
  nextCursor: string | null;
}

/**
 * A workspace dataset's screen: under the workspace's Documents (the screen
 * opens it there; a pasted URL of it becomes a reference).
 */
export const WORKSPACE_DATASET_REF_PATHS = [
  "/:slug/documents/datasets/:id",
] as const;

export const workspaceDatasetPath = (workspace: string, id: string) =>
  `/${workspace}/documents/datasets/${id}`;

/** Where a workspace's dataset lives. */
export interface WsDatasetPlace {
  datasetId: string;
  workspace: { id: string; slug: string; name: string };
  space: { id: string; slug: string; name: string };
}
